function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 366 239",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mesa-de-trabajo1",
    serifId: "Mesa de trabajo1",
    transform: "matrix(0.982586,0,0,1,-1031.72,-1639.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1050,
    y: 1639.03,
    width: 371.564,
    height: 238.606,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01772,0,0,1,876.334,1531.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.57709,-3.2741,-3.2741,-2.57709,285.578,273.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.728,10.06L11.841,10.06L20.303,4.091L14.406,-1.41L-1.728,10.06Z",
    style: {
      fill: "rgb(0,143,210)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.99297,-1.19052,-1.19052,-3.99297,228.288,288.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.948,2.271L25.885,2.271L22.094,-15.879L-10.857,-6.055L0.948,2.271Z",
    style: {
      fill: "rgb(0,143,210)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.5769,-3.27425,-3.27425,2.5769,418.739,176.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20.721,3.559L-7.152,3.559L1.31,9.53L-4.587,15.031L-20.721,3.559Z",
    style: {
      fill: "rgb(233,79,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.99297,-1.19052,-1.19052,3.99297,409.399,285.361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.568,-6.498L9.369,-6.498L5.577,11.652L-27.372,1.828L-15.568,-6.498Z",
    style: {
      fill: "rgb(233,79,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,341.5,131.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.452L2.968,9.547L6.009,10.474L6.01,10.453L15.999,13.414L3.067,-2.977L-9.848,13.429L-3.401,11.509L0,10.452Z",
    style: {
      fill: "rgb(233,79,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,353.865,135.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.642L0.1,-3.882L-12.816,12.524L0,8.642Z",
    style: {
      fill: "rgb(0,143,210)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,353.953,190.249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.775L2.038,8.354L2.715,0.129L-0.018,-0.598L-2.651,0.129L-1.958,8.373L0,7.775Z",
    style: {
      fill: "rgb(233,79,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.97833,1.23854,1.23854,3.97833,366.955,323.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.908,-19.899L-1.243,-19.899L3.064,-0.454L-4.386,-18.9L-2.908,-19.899Z",
    style: {
      fill: "rgb(233,79,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,353.707,190.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.794L0.059,7.811L0.041,-0.579L-2.592,0.148L-1.9,8.373L0,7.794Z",
    style: {
      fill: "rgb(0,143,210)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.97834,1.23852,1.23852,3.97834,360.559,324.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.381,-19.675L-2.779,-19.675L1.532,-0.212L-4.459,-19.623L-4.381,-19.675Z",
    style: {
      fill: "rgb(0,143,210)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIso);
export default __webpack_public_path__ + "static/media/iso.132bdea18face3b5a44e65006a798969.svg";
export { ForwardRef as ReactComponent };